var React = require('react');

function QuoteBottom (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M53.3,29.36,54.08,25H43L48.38,0H74l-6,27.57q-3.63,16.6-10.87,23.75Q49.68,58.73,35.71,60l2.58-13.53c4.32-.68,7.59-2.3,9.84-4.85S52.09,35,53.3,29.36ZM0,60,2.59,46.47q6.47-1,9.83-4.85t5.17-12.26L18.37,25H7.24L12.68,0H38.29L32.34,27.57q-3.62,16.6-10.86,23.75Q14,58.73,0,60Z","transform":"translate(0 0)"}));
}

QuoteBottom.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 74 60"};

module.exports = QuoteBottom;

QuoteBottom.default = QuoteBottom;
